import { ref, isRef, Ref } from 'vue'
import { useQuery } from '@cqrs/vue-composables-cqrs'
import * as q from './queries-core'
export function useRevenueAccountByIdQueryV1(workspaceId?: number | Ref<number>, strategyId?: string | Ref<string>, revenueId?: string | Ref<string>, ) {
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>(workspaceId)
	const _strategyId = isRef<string>(strategyId) ? strategyId : ref<string>(strategyId)
	const _revenueId = isRef<string>(revenueId) ? revenueId : ref<string>(revenueId)
	const result = {
		workspaceId: _workspaceId,
		strategyId: _strategyId,
		revenueId: _revenueId,
		...useQuery(() => new q.RevenueAccountByIdQueryV1(_workspaceId.value, _strategyId.value, _revenueId.value))
	}
	return {
		...result,
		runRevenueAccountByIdQueryV1: result.run,
		modelRevenueAccountByIdQueryV1: result.model,
	}
}

export function useRevenueAccountsByStrategyIdQueryV1(workspaceId?: number | Ref<number>, strategyId?: string | Ref<string>, ) {
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>(workspaceId)
	const _strategyId = isRef<string>(strategyId) ? strategyId : ref<string>(strategyId)
	const result = {
		workspaceId: _workspaceId,
		strategyId: _strategyId,
		...useQuery(() => new q.RevenueAccountsByStrategyIdQueryV1(_workspaceId.value, _strategyId.value))
	}
	return {
		...result,
		runRevenueAccountsByStrategyIdQueryV1: result.run,
		modelRevenueAccountsByStrategyIdQueryV1: result.model,
	}
}

